import styles from './Cookie.module.css'
import { useEffect, useState } from 'react'

// import { initMixpanel } from '../../helpers/mixpanel'
import Link from 'next/link'

export default function CookieAcceptance () {
  const [showCookie, setShowCookie] = useState(false)
  const [showCookiePopup, setShowCookiePopup] = useState(false)

  useEffect(() => {
    regionCheck()
  }, [])

  const regionCheck = async () => {
    const response = await window.fetch('/')
    if (response.ok) {
      const region = response.headers.get('x-header-country')
      if (region === 'europe') {
        const cookiesAccepted = window.localStorage.getItem('cookiesAccepted')
        if (cookiesAccepted === 'true') {
          // const isProduction = window.location.hostname === 'thesafehouse.sg'
          // initMixpanel(!isProduction)
        } else if (cookiesAccepted !== 'false') {
          setShowCookie(true)
        }
      } else {
        internalCheck()
      }
    } else {
      internalCheck()
    }
  }

  const internalCheck = async () => {
    // const isProduction = window.location.hostname === 'thesafehouse.sg'
    const isInternal = window.localStorage.getItem('isInternal')
    if (isInternal === 'true') {
      // Do not initialize Mixpanel for internal users
    } else if (isInternal === 'false' && window.localStorage.getItem('lastInternalChecked') && (Date.now() - parseInt(window.localStorage.getItem('lastInternalChecked'))) < 3 * 24 * 60 * 60 * 1000) {
      // initMixpanel(!isProduction)
    } else {
      const response = await window.fetch('https://get-ip-address.it2323.workers.dev')
      if (response.ok) {
        const json = await response.json()
        if (json.ip && (json.ip.startsWith('203.118.56.') || json.ip.startsWith('101.127.220.'))) {
          window.localStorage.setItem('isInternal', 'true')
        } else {
          // initMixpanel(!isProduction)
          window.localStorage.setItem('isInternal', 'false')
          window.localStorage.setItem('lastInternalChecked', Date.now().toString())
        }
      } else {
        // initMixpanel(!isProduction)
        window.localStorage.setItem('isInternal', 'false')
        window.localStorage.setItem('lastInternalChecked', Date.now().toString())
      }
    }
  }

  const onAcceptCookies = (isAccepted) => {
    if (isAccepted === 'true') {
      window.localStorage.setItem('cookiesAccepted', isAccepted)
    } else {
      window.localStorage.setItem('cookiesAccepted', 'false')
    }
    setShowCookie(false)
    setShowCookiePopup(false)
  }

  return (
    <>
      {showCookie && (
        <div className={styles.cookiesAcceptance}>
          <p>We use cookies to improve your experience and analyze site traffic. Some cookies are optional and require your consent.</p>
          <div className={styles.actions}>
            <a onClick={() => setShowCookiePopup(true)}>More information</a>
            <button className={styles.btnPrimary + ' ' + styles.btnSmall} onClick={() => onAcceptCookies('true')}>Accept All Cookies</button>
          </div>
        </div>
      )}
      {showCookiePopup && (
        <div className={styles.cookiesPopup}>
          <div className={styles.cookiesPopupContent}>
            <h2>Cookies & Privacy</h2>
            <p>We use cookies and similar technologies to improve site functionality, understand visitor traffic, and enhance your experience. Some cookies are essential, while others require your consent. By clicking "Accept All Cookies", you agree to the use of non-essential cookies as described in our <Link href='https://silverbullion.com.sg/privacy'>Privacy Policy</Link>. You can update your preferences anytime.</p>
            <h3>Manage Cookie Preferences</h3>
            <table>
              <tbody>
                <tr>
                  <td>
                    <p><strong>Essential Cookies</strong></p>
                    <p><i>These cookies are required for the website to function properly. They support secure access, session integrity, form submissions, and key preference handling such as maintaining your selected currency within an active session.</i></p>
                  </td>
                  <td>
                    <strong>ACTIVE</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p><strong>Analytics Cookies</strong></p>
                    <p><i>These cookies help us understand how visitors interact with our website, such as how they arrive, which pages are visited, and how long users stay. We use this information to improve the performance and usability of our website.</i></p>
                  </td>
                  <td>
                    <strong>NO</strong>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className={styles.actions}>
              <button className={styles.btnInfo} onClick={() => onAcceptCookies('false')}>Reject Non-Essential</button>
              <button className={styles.btnPrimary} onClick={() => onAcceptCookies('true')}>Accept All Cookies</button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
